<template>
    <div class="productInfoBox">
        <div class="indexTop clearfix">
            <div class="headBox">
                <div class="headTop">
                    <div class="box">
                        <i class="icon icon_logo" @click="goHomePage()"></i>
                        <a href="http://www.aiyechen.com" target="_blank" title="野尘出品" class="ycCopyright">➲ 野尘出品</a>
                        <div class="searchBox">
                            <ul><!--
                                --><li :class="isSearchTab=='company'?'isActive':''" @click="clickSearchTab('company')">公司</li>
                                <li :class="isSearchTab=='product'?'isActive':''" @click="clickSearchTab('product')">产品</li><!--
                            --></ul>
                            <div class="searchInp">
                                <el-input :placeholder="isSearchTab=='company'?'请输入公司代码、名称':'请输入产品名称，如动力煤、炼焦煤、焦炭等'" v-model="searchKey" class="input-with-select"  @keyup.enter.native="indexSearch()"></el-input>
                                <span @click="indexSearch()" class="btn">搜索</span>
                            </div>

                        </div>
                        <div class="myFavorite">
                            <span @click="queryMyFavorite" class="btn">我的收藏</span>
                        </div>
                        <div class="userInfo" @click="goPersonalInfo()">
                            <span class="userNam"> {{ userInfo.userName }}</span>
                            <span class="company" >{{ userInfo.companyName }}</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="productInfo container">
            <div class="titleTop">
                <div v-if="!isEmpty&&productRouterInfo.type == 'company'">
                    <span>{{ productShowInfo.name }}</span>{{ productShowInfo.code }}
                </div>
                <div v-if="!isEmpty&&productRouterInfo.type == 'product'">
                    <span>{{ productShowInfo.name }}</span>{{ productShowInfo.industry }}
                </div>
                <div v-if="isEmpty">未搜索到相关结果！</div>
                <div class="favorite">
                    <el-button @click="addMyFavoriteItem">添加收藏</el-button>
                </div>
                <div class="btnRight">
                    <el-button @click="queryHistoryOpeParam('-')" :disabled="index==-4||isLastPage">←</el-button>
                    <el-button @click="queryHistoryOpeParam('+')" :disabled="index==0">→</el-button>
                </div>
            </div>
            <div class="productContent">
                <div class="productLeft">
                    <ul>
                        <li v-for="(item,index) in leftList" :key="index" :class="isSelLi==index&&!isEmpty?'liActive':''" @click="clickTabsLeft(index)">
                           <a  @click="clickLeftLi=('first'+index)">
                                <i :class="isEmpty || isSelLi!=index?'icon icon_sidebar':'icon icon_sidebar_active'"></i>
                                {{ item }}
                           </a>
                        </li>
                    </ul>
                </div>
                <div class="productRight" v-if="paramsInfo.type&&paramsInfo.type == 'product'">
                    <ProductChain v-if="clickLeftLi == 'first0'&&!isEmpty"></ProductChain>
                    <ProductData v-if="clickLeftLi == 'first1'&&!isEmpty"></ProductData>
                    <CompanyListPro v-if="clickLeftLi == 'first2'&&!isEmpty"></CompanyListPro>
                    <Empty v-if="isEmpty"></Empty>
                </div>
                <div class="productRight" v-if="paramsInfo.type&&paramsInfo.type == 'company'">
                     <CoreProduct v-if="clickLeftLi == 'first0'&&!isEmpty"></CoreProduct>
                    <CoreDriver v-if="clickLeftLi == 'first1'&&!isEmpty"></CoreDriver>
                    <CoreConcept v-if="clickLeftLi == 'first2'&&!isEmpty"></CoreConcept>
                    <CompanyListCom v-if="clickLeftLi == 'first3'&&!isEmpty"></CompanyListCom>
                    <Empty v-if="isEmpty"></Empty>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {mapState} from 'vuex'
    import ProductChain from '../components/productInfoComponents/productCom/productChain.vue'
    import ProductData from '../components/productInfoComponents/productCom/productData.vue'
    import CompanyListPro from '../components/productInfoComponents/productCom/companyList.vue'
    import CompanyListCom from '../components/productInfoComponents/companyCom/companyList.vue'
    import CoreDriver from '../components/productInfoComponents/companyCom/coreDriver.vue'
    import CoreProduct from '../components/productInfoComponents/companyCom/coreProduct.vue'
    import CoreConcept from '../components/productInfoComponents/companyCom/coreConcept.vue'
    import Empty from '../components/productInfoComponents/empty.vue'
    import ssUtil from '@/utils/SStorage'
    import $ from 'jquery'
  export default {
    name: 'productInfo',
    data() {
        return {
            isSearchTab:'company',  //顶部搜索tab
            isSearchEnd:false,      //是否搜索结束
            searchKey:'',           //关键词搜索
            clickLeftLi:'first0',
            isSelLi:0,
            leftList:['产品链','产品数据','生产公司'],
            paramsInfo:{},
            isEmpty:false,
            index:0,
            isLastPage:false,
        }
    },
    components:{ProductChain,ProductData,CompanyListPro,CoreDriver,CoreProduct,CoreConcept,CompanyListCom,Empty},
    computed:{...mapState(['indexSearchInfo','proPageSearchParams','productShowInfo','productRouterInfo','userInfo'])},
    created(){
        if( !this.$route.params.name&&ssUtil.getItem('store')){
            this.$store.dispatch('productRouterInfo',ssUtil.getItem('store').productRouterInfo)
        }else{
            this.$store.dispatch('productRouterInfo',this.$route.params)
        }
        document.title = this.productRouterInfo.name
        this.paramsInfo = this.productRouterInfo
        if( this.productRouterInfo.type == 'product'){
            let params = {}
            params.name = this.productRouterInfo.name ;
            params.code = this.productRouterInfo.productCode;
            params.industry =  this.productRouterInfo.industry
            this.$store.dispatch('productShowInfo',params)
            this.leftList = ['产业链','产品数据','生产公司']
        }else if( this.productRouterInfo.type == 'company'){
            let params = {}
            params.name = this.productRouterInfo.name ;
            params.code = this.productRouterInfo.securityCode;
            this.$store.dispatch('productShowInfo',params)
            this.leftList = ['核心产品','核心驱动','核心概念','相关公司']
            this.getCompanyCoreProduct(this.productRouterInfo);
        }
        this.$nextTick( function(){
            $(window).scrollTop(0)
        })
    },
    methods: {
        //选择搜索tab
        clickSearchTab(str){
            this.isSearchTab = str;
        },
        //选择左边tab栏
        clickTabsLeft(index){
            this.isSelLi = index;
        },
        //获取公司核心产品信息
        getCompanyCoreProduct(obj){
            this.$store.dispatch('getCompanyCoreProduct',{coCode:obj.coCode}).then( res => {
                if( res.data.retCode == '000'){
                   this.$store.dispatch( 'indexSearchInfo' , res.data.data)
                   this.isFlag = true;
                }
            })
        },
        //关键词搜索
        indexSearch(){
            let urlParams = '';
            if( this.searchKey.trim()==''){
                return;
            }else if( this.isSearchTab == 'product'){
                urlParams = 'productSearch';
            }else if( this.isSearchTab == 'company'){
                urlParams = 'companySearch'
            }
            this.$store.dispatch( urlParams , { keyword: this.searchKey }).then( res => {
                if( res.data.retCode == '000'){
                    this.$store.dispatch( 'indexSearchInfo' , res.data.data)
                    this.isSearchEnd = true;
                    if( res.data.data.length>1){
                        this.isEmpty = false;
                        let params = {};
                        params.searchTab = this.isSearchTab;
                        params.searchKey = this.searchKey;
                        params.flag = 'productInfo'
                        this.$store.dispatch('proPageSearchParams',params)
                        this.$router.push({
                            path:'/dashBoard'
                        })
                    }else if(res.data.data.length==1){
                        this.isEmpty = false;
                        let retData = res.data.data[0]
                        if(this.isSearchTab == 'product'){
                          let params = {
                              type: 'product',
                              name:retData.productName,
                              industry:retData.industry,
                              productCode:retData.productCode
                          }
                          this.$store.dispatch('productRouterInfo',params)
                          this.$router.push({name:'productInfo',params:params})
                        }else if(this.isSearchTab == 'company'){
                          let params = {
                              type: 'company',
                              coCode:retData.coCode,
                              securityCode:retData.securityCode,
                              name:retData.securityName
                          }
                           this.$store.dispatch('productRouterInfo',params)
                          this.$router.push({name:'productInfo',params:params})
                        }
                    }else if(res.data.data.length==0){
                        document.title = '未搜索到相关结果！'
                        this.isEmpty = true;
                        if( this.isSearchTab == 'product'){
                            this.leftList = ['产业链','产品数据','生产公司']
                        }else if( this.isSearchTab == 'company'){
                           this.leftList = ['核心产品','核心驱动','核心概念','相关公司']
                        }
                    }
                }
            })
        },
        //返回首页
        goHomePage(){
            this.$router.push({
                path:'/dashBoard'
            })
        },
        //进入个人中心或者登录页
        goPersonalInfo(){
            //个人中心
            this.$router.push({
                path:'/personal',
            })
        },
        //增加详情操作记录
        addHistoryOpeParam(params){
            this.$store.dispatch('addHistoryOpeParam',{opeParam:JSON.stringify(params)}).then( res => {
                if( res.data.retCode == '000' ){}
            })
        },
        //  查询历史操作记录
        queryHistoryOpeParam(flag){
            if( flag == '+'){
                if(this.index == 0){
                    return
                }else{
                    this.index++
                }

            }else if( flag == '-' ){
                if(this.index == -4){
                    return
                }else{
                    this.index--
                }
            }
            this.$store.dispatch('queryHistoryOpeParam',{index:this.index}).then( res => {
                if( res.data.retCode == '000' ){
                    let params = JSON.parse(res.data.data.paramJson)
                    this.isLastPage = - res.data.data.size >= this.index
                    params.opt = 'search'
                    this.$store.dispatch('productRouterInfo',params)
                }
            })
        },
        addMyFavoriteItem(){
            let params = {}
            if( this.productRouterInfo.type == 'product'){
                params.name = this.productRouterInfo.name
                params.code = this.productRouterInfo.productCode
                params.innerId = this.productRouterInfo.productCode
                params.industry =  this.productRouterInfo.industry
                params.type = 2
            }else if( this.productRouterInfo.type == 'company'){
                params.name = this.productRouterInfo.name
                params.code = this.productRouterInfo.securityCode
                params.innerId = this.productRouterInfo.coCode
                params.industry = ''
                params.type = 1
            }
            this.$store.dispatch('addMyFavoriteItem',{myFavorite:JSON.stringify(params)}).then( res => {
                this.$message({
                    message: "添加成功",
                    type: "success",
                    center: true,
                    showClose: false,
                    duration: 800
                });
            })
        },
        queryMyFavorite(){
            this.$router.push({path:'/myFavorite'})
        }
    },
    mounted() {},
    watch:{
        productRouterInfo:{
            handler(newVla, oldVal) {
                  if( this.productShowInfo.name != this.productRouterInfo.name){
                    let params = {}
                    if( this.productRouterInfo.type == 'product'){
                        params.name = this.productRouterInfo.name ;
                        params.code = this.productRouterInfo.productCode;
                        params.industry =  this.productRouterInfo.industry
                        this.$store.dispatch('productShowInfo',params)
                    }else if( this.productRouterInfo.type == 'company'){
                        params.name = this.productRouterInfo.name ;
                        params.code = this.productRouterInfo.securityCode;
                        this.$store.dispatch('productShowInfo',params)
                    }
                    document.title = this.productRouterInfo.name
                    this.clickLeftLi = 'first0'
                    this.isSelLi = 0;
                    this.paramsInfo.type = this.productRouterInfo.type
                    params = this.productRouterInfo //公司：type、coCode、securityCode、name 产品：type、productCode、name、industry
                    if(this.productRouterInfo.type == 'product'){
                        this.leftList = ['产业链','产品数据','生产公司']
                    }else{
                        this.leftList = ['核心产品','核心驱动','核心概念','相关公司']
                    }
                    if(!this.productRouterInfo.opt){
                        this.addHistoryOpeParam(params);
                    }
                }
            },
            deep: true,
        },
    }
  }
</script>


<style lang="scss" src="../sass/productInfo.scss" ></style>



// WEBPACK FOOTER //
// src/view/productInfo.vue